// tslint:disable
export enum EnrollmentJobType {
    /**
     * @description QP Enrollment Feed
     */
    EnrollmentFeed = 1,
}
(EnrollmentJobType as any)['ENROLLMENTFEED'] = 1;
